
    const data = {"name":"src/core/icons/message-badge","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M22 7v9c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h10.1c-.1.3-.1.7-.1 1 0 2.8 2.2 5 5 5 1.1 0 2.2-.4 3-1m-6-4c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3-3 1.3-3 3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            